import { EscHotKeyIcon } from '@modules/common/components/HotKeyIcons';
import { CmdHotKeyIcon } from '@modules/common/components/HotKeyIcons/CmdHotKeyIcon';
import { useHotkey } from '@modules/common/hooks';
import { KeyboardReturnRounded } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import { Button, Paper, Stack } from '@mui/material';

interface CreateNewUnifiedFieldDrawerFooterProps {
  onClose: () => void;
  createUnifiedField: () => Promise<void>;
  loading: boolean;
  disableCreateButton?: boolean;
}

export const CreateNewUnifiedFieldDrawerFooter = ({
  onClose,
  createUnifiedField,
  loading,
  disableCreateButton,
}: CreateNewUnifiedFieldDrawerFooterProps) => {
  useHotkey({
    hotkey: '$mod+enter',
    onHotkey: createUnifiedField,
    isHotKeyDisabled: disableCreateButton,
  });

  return (
    <Paper
      sx={{
        mt: 'auto',
        p: 1,
        bottom: 0,
        position: 'sticky',
      }}
    >
      <Stack
        direction="row"
        ml="auto"
        justifyContent="flex-end"
        alignItems="center"
        spacing={1}
      >
        <Button
          variant="outlined"
          color="primary"
          onClick={onClose}
          endIcon={<EscHotKeyIcon />}
        >
          Back
        </Button>
        <LoadingButton
          variant="contained"
          color="primary"
          onClick={createUnifiedField}
          loading={loading}
          disabled={disableCreateButton}
          endIcon={
            <CmdHotKeyIcon
              plusHotKeyNode={<KeyboardReturnRounded />}
              isDisabled={disableCreateButton}
            />
          }
        >
          Create Unified Field
        </LoadingButton>
      </Stack>
    </Paper>
  );
};
